/* eslint-disable */
export const D360_LOAD_PROJECTS_START = 'D360_LOAD_PROJECTS_START';
export const D360_LOAD_PROJECTS_SUCCESS = 'D360_LOAD_PROJECTS_SUCCESS';
export const D360_LOAD_PROJECTS_FAIL = 'D360_LOAD_PROJECTS_FAIL';
